import type { alibabaModelConfig } from './types';
import { qwenConfigs } from './configs/qwen';
import { wanConfigs } from './configs/wan';
import { zimageConfigs } from './configs/zimage';

export const alibabaModelConfigs: Record<string, alibabaModelConfig> = {
    ...qwenConfigs,
    ...wanConfigs,
    ...zimageConfigs,
};